export const Regexes = Object.freeze({
  ANY: /.*/,
  PHONE: /^[0-9\\. ()-]*$/,
  FORMATTED_PHONE: /^(\d{3})-?(\d{3})-?(\d{4})$/,
  FORMATTED_CC: /^(\d{4})-(\d{4})-(\d{4})-(\d{4})$/,
  PHONE_ALL_MATCH: /^(\d)\1{9}$/,
  EMAIL: /^[a-zA-Z0-9.!#$%&’*+/=?^_{|}~-]+@[a-zA-Z0-9-]+(?:.[a-zA-Z0-9-]+)*$/,
  NAME: /^[a-zA-Z0-9\\. '-]*$/,
  TWENTY_MAX: /^.{0,20}$/,
  FORMATTED_NAME: /^[a-zA-Z0-9\\. '-]{1,20}$/,
  FORMATTED_ID_NUMBER: /^[a-zA-Z0-9*]*$/,
  ID_LENGTH: /^.{6,30}$/,
  SSN: /^\d{9}$/,
  OTP_LENGTH: /^[0-9]{6,6}$/,
  ID_EXPIRES: /^[0-1]\d{3}$/,
  NUMBER: /^[0-9]*$/,
  FORMATTED_BANK_ACCOUNT: /^[0-9]{4,17}$/,
  FORMATTED_ROUTING_NUMBER: /^[0-9]{8,9}$/,
  RESPONSE_MESSAGE_PHONE: /[0-9]-[0-9]{3}-[0-9]{3}-[0-9]{4}/g,
  ADDRESS: {
    ALLOWED_CHARACTERS: /^[a-zA-Z0-9#\\. -]*$/,
    FORMATTED:          /^[a-zA-Z0-9#\\. -]{1,30}$/,
  },
  CITY: {
    ALLOWED_CHARACTERS: /^[a-zA-Z\\. -]*$/,
    FORMATTED: /^[a-zA-Z\\. -]{1,20}$/,
  },  
  UNIT: {
    ALLOWED_CHARACTERS: /^[a-zA-Z0-9\\./ -]*$/,
    FORMATTED: /^[a-zA-Z0-9\\./ -]{0,5}$/,
  },
  ZIP: {
    ALLOWED_CHARACTERS: /^[0-9:-]*$/,
    FORMATTED_US: /^(([0-9]{5})|([0-9]{9})|([0-9]{5}(-[0-9]{4})))?$/,
  },
  HOUSE_NUMBER: {
    ALLOWED_CHARACTERS: /^[a-zA-Z0-9\\./ -]*$/,
    FORMATTED_US: /^[a-zA-Z0-9\\./ -]{0,6}/,    
  },
  ID_NUMBER: {
    ALLOWED_CHARACTERS: /^[a-zA-Z0-9*]/
  }
});
